export default {
  TAGS: 'tags',
  NOTIFICATIONS: 'notifications',
};
